import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";

function CounterPanel() {
  const [current, setCurrent] = useState(null);
  const [queue, setQueue] = useState([]);
  const [stats, setStats] = useState({
    pending: 0,
    completed: 0,
    skipped: 0,
    total: 0,
  });

  const counterId = localStorage.getItem("counterId");
  //const counterId = localStorage.getItem("counterId") || 1;

  const loadData = async () => {
    try {
      const currentRes = await api.get(`/Token/current/${counterId}`);

      const queueRes = await api.get(`/Token/queue/${counterId}`);

      const statsRes = await api.get(`/Token/stats/${counterId}`);

      setCurrent(currentRes.data);
      setQueue(queueRes.data);
      setStats(statsRes.data);
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error",
      );
      console.error(error);
    }
  };

  const callNext = async () => {
    try {
      await api.post(`/Token/callnext/${counterId}`);

      loadData();
    } catch (error) {
      console.error(error);
      //alert("Failed to call next token");
      Swal.fire("Alert", "No Pending Token", "info");
      //alert("No Pending Token");
    }
  };

  const completeToken = async () => {
    try {
      await api.post(`/Token/complete/${counterId}`);

      loadData();
    } catch (error) {
      console.error(error);
      Swal.fire("Alert", "All Token Completed", "success", "timer: 2000");

      //       Swal.fire({
      //   title: "Auto close alert!",
      //   text: "I will close in 2 seconds.",
      //   timer: 2000
      // });
      //alert("All Token Completed");
    }
  };

  const skipToken = async () => {
    try {
      await api.post(`/Token/skip/${counterId}`);

      loadData();
    } catch (error) {
      console.error(error);
      //alert("No Serving Token Active");
      Swal.fire("Alert", "No Serving Token Active", "info");
    }
  };

  const recallToken = async () => {
    try {
      const response = await api.post(`/Token/recall/${counterId}`);

      // alert(
      //   `Recalled Token : ${response.data.tokenNo}`
      // );
      alert(
        `Token ${response.data.tokenNo} Please come to Counter ${response.data.counterId}`,
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();

    const interval = setInterval(() => {
      loadData();
    }, 3000);

    return () => clearInterval(interval);
  });

  return (
    <div className="container-fluid">
      {/* <div className="row mb-4">
        <div className="col-md-12 text-center">
          <h1>Counter Panel</h1>
          <h4>Counter : {counterId}</h4>
        </div>
      </div> */}

      <div className="row mb-3">
        <div className="col-md-4">
          <div className="card text-center p-3 bg-light">
            <h5>Current Token</h5>
            {current ? (
              <>
                <h1
                  style={{
                    fontSize: "50px",
                    fontWeight: "bold",
                    color: "green",
                  }}
                >
                  {current.tokenNo}
                </h1>

                <div>Counter No. {current.counterId}</div>
              </>
            ) : (
              <h3>No Token</h3>
            )}
          </div>
        </div>
        <div className="col-md-8">
          <div className="row g-4">
            <div className="col-md-3 col-6">
              <div className="card text-center p-3 text-danger">
                <h5>Pending</h5>
                <h2>{stats.pending}</h2>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="card text-center p-3 text-primary">
                <h5>Skipped</h5>
                <h2>{stats.skipped}</h2>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="card text-center p-3 text-success">
                <h5>Completed</h5>
                <h2>{stats.completed}</h2>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="card text-center p-3 text-info">
                <h5>Total</h5>
                <h2>{stats.total}</h2>
              </div>
            </div>
          </div>
          <div className="row p-4">
            <div className="col-md-12 text-center">
              <button className="btn btn-warning me-2" onClick={callNext}>
                Call Next
              </button>

              <button className="btn btn-primary me-2" onClick={skipToken}>
                &nbsp;&nbsp;&nbsp;Skip&nbsp;&nbsp;&nbsp;
              </button>

              <button className="btn btn-success me-2" onClick={completeToken}>
                Complete
              </button>

              <button className="btn btn-info" onClick={recallToken}>
                Recall
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3>Waiting Queue</h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Token No</th>
                    <th>Customer Name</th>
                    <th>Mobile No</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {queue.length > 0 ? (
                    queue.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.tokenNo}</td>
                        <td>{item.customerName}</td>
                        <td>{item.mobileNo}</td>
                        <td>{item.status}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Waiting Tokens
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CounterPanel;
